import { compose, lifecycle, withStateHandlers } from 'recompose';
import { defaultStyle } from '@signavio/ui';
import { utils } from '@signavio/effektif-commons';
import { jsx as _jsx } from "react/jsx-runtime";
function FadeElement({
  children,
  style
}) {
  return /*#__PURE__*/_jsx("div", {
    ...style,
    children: children
  });
}
const enhance = compose(withStateHandlers({
  highlight: false
}, {
  onHighlight: () => () => ({
    highlight: true
  }),
  onLowlight: () => () => ({
    highlight: false
  })
}), lifecycle({
  componentDidUpdate(prevProps) {
    const {
      required,
      onHighlight,
      onLowlight
    } = this.props;
    const willBecomeMandatory = !prevProps.required && required;
    if (willBecomeMandatory) {
      onHighlight();
      setTimeout(onLowlight, 2000);
    }
  }
}), defaultStyle(({
  color
}) => ({
  ...utils.transition(['background-color', 'max-height', 'opacity'], 'ease-in-out'),
  display: 'none',
  backgroundColor: 'transparent',
  maxHeight: 0,
  opacity: 0,
  '&entering': {
    display: 'block',
    maxHeight: '100%'
  },
  '&entered': {
    display: 'block',
    opacity: 1,
    maxHeight: null
  },
  '&exiting': {
    display: 'block',
    maxHeight: '100%'
  },
  '&highlight': {
    backgroundColor: color.primary.light
  }
}), ({
  highlight,
  state
}) => ({
  '&highlight': highlight,
  [`&${state}`]: true
})));
export default enhance(FadeElement);